import { createSelector } from "reselect";

import { parsePermissionMap, PERMISSIONS_VERSION } from "@fitness-app/data-models";

import { type AppStore } from "../../../index";

const getCustomClaims = (state: AppStore) => state.user.customClaims;

export const getUserPermissions = createSelector([getCustomClaims], (customClaims) => {
  if (customClaims?.permissionsVersion !== PERMISSIONS_VERSION) {
    return {};
  }

  return parsePermissionMap(customClaims.permissions);
});
